export default __webpack_public_path__ + "static/media/misc-books1.9172313c.jpg";